import { useEffect, useState } from "react";
import { API } from "@/lib/api";
import { User as UserIcon } from "lucide-react";

/**
 * Shows the user's avatar if they have one, otherwise a placeholder icon.
 * Uses a cache-busting query string tied to avatar_updated_at so updates reflect immediately.
 */
export default function UserAvatar({ user, size = 32, className = "" }) {
  const [errored, setErrored] = useState(false);
  const hasAvatar = user && (user.has_avatar || user.avatar_updated_at);
  const url = hasAvatar && user?.id ? `${API}/users/${user.id}/avatar?v=${encodeURIComponent(user.avatar_updated_at || "")}` : null;

  useEffect(() => { setErrored(false); }, [url]);

  const dim = { width: size, height: size };
  if (!url || errored) {
    return (
      <div
        className={`rounded-full bg-muted grid place-items-center text-muted-foreground ${className}`}
        style={dim}
        data-testid="user-avatar-placeholder"
      >
        <UserIcon className="w-1/2 h-1/2" strokeWidth={1.75} />
      </div>
    );
  }
  return (
    <img
      src={url}
      alt={user?.full_name || "avatar"}
      className={`rounded-full object-cover ${className}`}
      style={dim}
      onError={() => setErrored(true)}
      data-testid="user-avatar-img"
    />
  );
}
